<template>
  <div>
    <div class="container-fluid">
      <div class="row p-3" style="background:darkblue">
        <div class="col-9">
          <h2>Piaraam Admin</h2>
        </div>
        <div class="col-3 justify-content-between">
          <a @click="logOut" class="m-2 text-white" style="cursor: pointer"
            >LogOut</a
          >
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row mt-5">
        <div class="col-lg-2 p-0">
          <ul class="list-group">
            <li class="list-group-item px-2" @click="youtubeComponent()">
              Manage Youtube
            </li>
            <li class="list-group-item px-2" @click="soundcloudComponent()">
              Manage SoundCloud
            </li>
            <li class="list-group-item px-2">Morbi leo risus</li>
            <li class="list-group-item px-2">Porta ac consectetur ac</li>
            <li class="list-group-item px-2">Vestibulum at eros</li>
          </ul>
        </div>
        <div class="col-lg-10">
          <AdminYoutube v-if="AdminYoutubeBtn == true" />
          <AdminSoundcloud v-if="AdminSoundcloudBtn == true" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import AdminYoutube from "./AdminYoutube";
import AdminSoundcloud from "./AdminSoundcloud";
export default {
  data() {
    return {
      AdminYoutubeBtn: false,
      AdminSoundcloudBtn: false,
    };
  },
  methods: {
    logOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          localStorage.removeItem("admin");
          this.$router.push({ name: "Login" });
        })
        .catch((err) => console.log(err));
    },
    youtubeComponent() {
      this.AdminYoutubeBtn = true;
      this.AdminSoundcloudBtn = false;
    },
    soundcloudComponent() {
      this.AdminYoutubeBtn = false;
      this.AdminSoundcloudBtn = true;
    },
  },
  components: {
    AdminYoutube,
    AdminSoundcloud,
  },
};
</script>
<style lang="scss" scoped>
li {
  cursor: pointer;
  background-color: darkblue !important;
  color: white;

  border-bottom: 1px solid white;
}
</style>
